export default __webpack_public_path__ + "static/media/tshirts.41c0f312.jpg";